// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ga5x","top":"styles_top__12FGM"};